<template>
	<v-col>
		<div class="d-flex justify-space-between">
			<div class="font-size-14 font-weight-bold secondary--text">Kirim Serial</div>
		</div>
		<div class="mt-5">
			<v-row>
				<v-col cols="12" sm="6" md="6" lg="3" xl="3">
					<v-card class="pa-4 elevation-0 rounded-xl hover-shadow">
						<v-row class="align-center">
							<v-col cols="12" sm="12" md="12" xl="12"><div class="font-size-12 primary--text">Input Kode Mitra</div></v-col>
						</v-row>
						<div class="pt-0">
							<v-text-field
								label=""
								color="primary"
								hide-details="auto"
								v-model="network_code"
								@keyup="(network_code) ? network_code = network_code.toUpperCase() : network_code"
								@blur="getMitraName(network_code, 'input')"
								:error-messages="(errorValidation !== undefined && errorValidation['network_code'] !== undefined ) ? [errorValidation['network_code']] : []"
							></v-text-field>
							<div class="pt-1 font-size-9" :class="(member_valid) ? 'green--text text--darken-2 text-uppercase' : 'red--text text--darken-2'" v-if="member_valid">
								{{ (member_name) ? '[' + member_name + ']' : '' }}
							</div>
						</div>
					</v-card>
				</v-col>
				<v-col cols="12" sm="6" md="6" lg="3" xl="3">
					<v-card class="pa-4 elevation-0 rounded-xl hover-shadow">
						<v-row class="align-center">
							<v-col cols="12" sm="12" md="12" xl="12"><div class="font-size-12 primary--text">Jumlah Serial {{ setSerialTypeText(show_serial) }}</div></v-col>
						</v-row>
						<div class="pt-3 d-flex flex-row align-center">
							<v-btn small depressed color="secondary" icon outlined class="white--text rounded-pill" :disabled="serial_qty <= 0" @click="decInput()">
								<v-icon small>mdi-minus</v-icon>
							</v-btn>

							<v-text-field ref="serialqty" label="" color="primary" hide-details="auto" v-model="serial_qty" @keypress="onlyNumber" class="pt-0 mt-0 mx-5 text-center" :rules="rules.qty_serial"></v-text-field>
						
							<v-btn small depressed color="secondary" icon outlined class="white--text rounded-pill" @click="addInput()">
								<v-icon small>mdi-plus</v-icon>
							</v-btn>
						</div>
					</v-card>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12">
					<v-card class="pa-3 elevation-0 rounded-xl hover-shadow">
						<v-tabs class="tabs-vo no-slider">
							<v-tab class="rounded-xl" :disabled="tab_disabled" @click="changeTabSerial('ceria')">Serial Ceria</v-tab>
							<v-tab class="rounded-xl" :disabled="tab_disabled" @click="changeTabSerial('ekonomi')">Serial Ekonomis</v-tab>
							<v-tab class="rounded-xl" :disabled="tab_disabled" @click="changeTabSerial('star')">Serial Premium</v-tab>
							<v-tab class="rounded-xl" :disabled="tab_disabled" @click="changeTabSerial('supreme')">Serial Supreme</v-tab>
							<v-tab class="rounded-xl" :disabled="tab_disabled" @click="changeTabSerial('elite')">Serial Free</v-tab>
							<!-- <v-tab class="rounded-xl" :disabled="tab_disabled" @click="changeTabSerial('ro')">Serial Repeat Order</v-tab> -->
						</v-tabs>
					</v-card>
				</v-col>
			</v-row>
			<v-scroll-x-transition mode="in-out" :hide-on-leave="true">
				<SerialStar :network_code="network_code" :nama_mitra="member_name" :serialqty="parseInt(serial_qty)" v-if="show_serial == 'star'" @action="resetNetworkCode" @loadtab="getTotalSerial"></SerialStar>
			</v-scroll-x-transition>
			<v-scroll-x-transition mode="in-out" :hide-on-leave="true">
				<SerialElite :network_code="network_code" :nama_mitra="member_name" :serialqty="parseInt(serial_qty)" v-if="show_serial == 'elite'" @action="resetNetworkCode" @loadtab="getTotalSerial"></SerialElite>
			</v-scroll-x-transition>
			<v-scroll-x-transition mode="in-out" :hide-on-leave="true">
				<SerialEkonomi :network_code="network_code" :nama_mitra="member_name" :serialqty="parseInt(serial_qty)" v-if="show_serial == 'ekonomi'" @action="resetNetworkCode" @loadtab="getTotalSerial"></SerialEkonomi>
			</v-scroll-x-transition>
			<v-scroll-x-transition mode="in-out" :hide-on-leave="true">
				<SerialCeria :network_code="network_code" :nama_mitra="member_name" :serialqty="parseInt(serial_qty)" v-if="show_serial == 'ceria'" @action="resetNetworkCode" @loadtab="getTotalSerial"></SerialCeria>
			</v-scroll-x-transition>
			<v-scroll-x-transition mode="in-out" :hide-on-leave="true">
				<SerialSupreme :network_code="network_code" :nama_mitra="member_name" :serialqty="parseInt(serial_qty)" v-if="show_serial == 'supreme'" @action="resetNetworkCode" @loadtab="getTotalSerial"></SerialSupreme>
			</v-scroll-x-transition>
			<!-- <v-scroll-x-transition mode="in-out" :hide-on-leave="true">
				<SerialRO :network_code="network_code" :nama_mitra="member_name" :serialqty="parseInt(serial_qty)" v-if="show_serial == 'ro'" @action="resetNetworkCode" @loadtab="getTotalSerial"></SerialRO>
			</v-scroll-x-transition> -->
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import SerialStar from './SerialStar';
import SerialElite from './SerialElite';
import SerialEkonomi from './SerialEkonomi';
import SerialCeria from './SerialCeria';
import SerialSupreme from './SerialSupreme';
// import SerialRO from './SerialRO';

export default {
	components: {
		SerialStar, SerialElite, SerialEkonomi, SerialCeria, SerialSupreme
	},
	data() {
		return {
			network_code: '',
			serial_qty: 0,
			tab_disabled: false,
			show_serial: 'ceria',
			member_name: '',
			member_valid: true,
			totalSerial: 0,
			rules: {
				qty_serial: [
					v => !!v || 'Qty serial wajib diisi (minimal 1)',
					v => ( v && v < (parseInt(this.totalSerial)+1) ) || "Jumlah serial yang dikirim tidak boleh melebihi jumlah serial yang tersedia",
				],
			},
		}
	},
	watch: {
		totalSerial() {
			this.$refs['serialqty'].validate(true)
		}
	},
	computed: {
		...mapState('opsi', ['memberData']),
		...mapState(['errorValidation']),
	},
	methods: {
		...mapActions('opsi', ['getMemberByCode']),
		...mapMutations('opsi', ['emptyMemberData']),
		...mapMutations(['emptyErrorValidation']),

		changeTabSerial(type) {
			this.show_serial = type
			this.tab_disabled = true
			setTimeout(() => {
				this.tab_disabled = false
			}, 500)
		},
		resetNetworkCode() {
			setTimeout(() => {
				this.network_code = ''
				this.serial_qty = 0
				this.member_name = ''
				this.member_valid = true
			}, 200);
		},

		addInput() {
			this.serial_qty++
		},

		decInput() {
			if (this.serial_qty > 0) this.serial_qty--
		},

		getMitraName(mitra_code, trigger) {
			if (mitra_code) {
				this.getMemberByCode({network_code: mitra_code})
				.then((response) => {
					if (Object.keys(response).length > 0) {
						if (trigger === 'input') {
							this.member_name = response.member_name
							this.member_valid = true
						}
					} else {
						this.member_name = ''
						this.member_valid = false
					}
					
				}).catch(() => {
					this.member_name = ''
					this.member_valid = false
				})
			} else {
				this.member_name = ''
				this.member_valid = false
			}
		},

		getTotalSerial(value) {
			this.totalSerial = value
		},

		setSerialTypeText(show_serial) {
			if (show_serial == 'star') return 'Premium'
			else if (show_serial == 'elite') return 'Free'
			else if (show_serial == 'ceria') return 'Ceria'
			else if (show_serial == 'ekonomi') return 'Ekonomis'
			else if (show_serial == 'supreme') return 'Supreme'
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Kirim Serial`)
	},
};
</script>